import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";
import { param } from "~/utils/url_helper";

export const useWorkloadGhostTasks = (params, config) => {
  if (!params.filter) {
    params.filter = "everything_in_all_projects_for_ghost_tasks";
  }
  return useQuery({
    ...config,
    queryKey: ["workload-ghost-tasks", params],
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/projects/calendar-events?${param(params)}`,
        signal,
      }),
  });
};
